module.exports = __webpack_public_path__ + "static/media/g-1-a.202899fd.jpg";